import { GraphQLClient } from 'graphql-request';

export const client = new GraphQLClient(process.env.REACT_APP_GRAPHQL_ENDPOINT, {
  headers: { Authorization: `Token ${localStorage.getItem('ep_token')}` },
});
